import type { Phase } from "./events";

export function shouldBargeIn(phase: Phase): boolean {
  return phase === "speaking";
}
